import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { PanelBarStateChangeEvent } from '@progress/kendo-angular-layout';
import { filter } from 'rxjs/operators';
import { CompanyBranchCreateModalComponent } from 'src/app/components/shared/companies/company-branch-create-modal/company-branch-create-modal.component';
import { CompanyCreateUpdateComponent, ICompanyCreateUpdateData } from 'src/app/components/shared/companies/company-create-update/company-create-update.component';
import { IApiBranch, IApiCompany } from 'src/app/shared/modules/graphql/types/types';

@Component({
  selector: 'app-company-information-cards',
  templateUrl: './company-information-cards.component.html',
  styleUrls: ['./company-information-cards.component.scss']
})
export class CompanyInformationCardsComponent {
  @Input() company: IApiCompany;
  @Input() type;
  @Input() cols = 2;
  @Output() reload = new EventEmitter<boolean>(false);
  @Output() activatePanelBar = new EventEmitter<number>();
  @Input() activeTabIndex = 1;

  constructor(
    private dialogService: DialogService
  ) {

  }

  public editCompany() {
    const dialog: DialogRef = this.dialogService.open({
      content: CompanyCreateUpdateComponent,
      width: "80%",
      preventAction: (ev) => {
        return ev !== ("closed" as any);
      },
    });
    const data: ICompanyCreateUpdateData = {
      companyId: this.company.id
    };
    const dialogInstance = dialog.content.instance as CompanyCreateUpdateComponent;
    dialogInstance.data = data;
    dialog.result
      .pipe(
        filter((v: DialogCloseResult) => {
          return !!v;
        }),
      )
      .subscribe(() => this.reload.emit(true));
  }

  public panelClicked(e: PanelBarStateChangeEvent) {
    const expanded = e?.items?.find(i => i?.expanded === true);
    if (expanded?.id) {
      this.activeTabIndex = +expanded?.id;
    } else {
      this.activeTabIndex = null;
    }
    this.activatePanelBar.emit(this.activeTabIndex);
  }

  public editBranch(branch: IApiBranch) {
    const dialog: DialogRef = this.dialogService.open({
      content: CompanyBranchCreateModalComponent,
      width: "80%",
      preventAction: (ev) => {
        return ev !== ("closed" as any);
      },
    });
    const dialogInstance = dialog.content.instance as CompanyBranchCreateModalComponent;
    dialogInstance.data = { branchId: branch.id };
    dialog.result
      .subscribe((response) => {
        if (response === true)
          this.reload.emit(true)
      });
  }
}

